exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-IsnIntegration-body{border:2px solid #069444 !important;border-radius:0 !important}.src-components-shared-IsnIntegration-body .src-components-shared-IsnIntegration-sideContent{display:-ms-flexbox;display:flex}.src-components-shared-IsnIntegration-body .src-components-shared-IsnIntegration-sideContent .src-components-shared-IsnIntegration-img{width:200px;height:100%;-o-object-fit:contain;object-fit:contain}", ""]);

// exports
exports.locals = {
	"body": "src-components-shared-IsnIntegration-body",
	"sideContent": "src-components-shared-IsnIntegration-sideContent",
	"img": "src-components-shared-IsnIntegration-img"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/IsnIntegration/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/IsnIntegration/styles.scss
// module chunks = 1